export const EnergyUseType = {
  ENERGY_PLAN: '0',
  DELAY_APPLICATION: '1',
};
export const EnergyUseDisplay = {
  [EnergyUseType.ENERGY_PLAN]: '用能计划',
  [EnergyUseType.DELAY_APPLICATION]: '延时用能申请',
};
export enum DelayTitleEnum {
  ALL = 5,
  REJECTED = 0, // 已拒绝
  DRAFT = 2, // 草稿
  PENDING = 3, // 待审批（PENDING 隐含“待处理/审批”含义，更简洁）
  APPROVED = 4, // 已批准
}
/** 审批状态枚举 */
export enum ApprovalStatus {
  /** 草稿 */
  DRAFT = 0,
  /** 已拒绝 */
  REJECTED = 1,
  /** 已批准 */
  APPROVED = 2,
  /** 待审批-一级审批 */
  PENDING_FIRST = 3,
  /** 待审批-二级审批 */
  PENDING_SECOND = 4,
  /** 已批准-自动审批 */
  APPROVED_AUTO = 5,
}

export const ApprovalStatusDisplay = {
  [ApprovalStatus.DRAFT]: '草稿',
  [ApprovalStatus.REJECTED]: '已拒绝',
  [ApprovalStatus.APPROVED]: '已批准',
  [ApprovalStatus.PENDING_FIRST]: '待审批-一级审批',
  [ApprovalStatus.PENDING_SECOND]: '待审批-二级审批',
  [ApprovalStatus.APPROVED_AUTO]: '已批准-自动审批',
};
export const ColorDisplay = {
  [ApprovalStatus.DRAFT]: 'default',
  [ApprovalStatus.REJECTED]: 'error',
  [ApprovalStatus.APPROVED]: 'success',
  [ApprovalStatus.PENDING_FIRST]: 'warning',
  [ApprovalStatus.PENDING_SECOND]: 'warning',
  [ApprovalStatus.APPROVED_AUTO]: 'success',
};
